import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserDto } from '@api/core';
import { currentUser$ } from '@stillmandigital/common';
import { map } from 'rxjs';

export const changePasswordGuard: CanActivateFn = () => {
  const router = inject(Router);

  return currentUser$<UserDto>().pipe(map(user => !user?.ssoOnly || router.createUrlTree(['/'])));
};
